import { render, staticRenderFns } from "./InventarioSimBase.vue?vue&type=template&id=b9e17adc&"
import script from "./InventarioSimBase.vue?vue&type=script&lang=ts&"
export * from "./InventarioSimBase.vue?vue&type=script&lang=ts&"
import style0 from "./InventarioSimBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b9e17adc', component.options)
    } else {
      api.reload('b9e17adc', component.options)
    }
    module.hot.accept("./InventarioSimBase.vue?vue&type=template&id=b9e17adc&", function () {
      api.rerender('b9e17adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/InventarioSim/InventarioSimBase.vue"
export default component.exports